// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"398d7e5a","480":"05ab3dac","862":"85f44212"}[chunkId] + ".chunk.css";
};